/**
 * Application constants - WordPress and concatenation compatible
 */
(function (global) {
  "use strict";

  // Application constants
  const BREAKPOINTS = {
    xs: 320,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400,
  };

  const ANIMATION_DURATION = {
    fast: 150,
    normal: 300,
    slow: 500,
  };

  const CSS_CLASSES = {
    active: "is-active",
    focused: "is-focused",
    visible: "is-visible",
    hidden: "is-hidden",
    loading: "is-loading",
  };

  const KEYCODES = {
    ENTER: "Enter",
    ESCAPE: "Escape",
    SPACE: " ",
    ARROW_UP: "ArrowUp",
    ARROW_DOWN: "ArrowDown",
    ARROW_LEFT: "ArrowLeft",
    ARROW_RIGHT: "ArrowRight",
    TAB: "Tab",
  };

  // Make constants available globally
  global.BREAKPOINTS = BREAKPOINTS;
  global.ANIMATION_DURATION = ANIMATION_DURATION;
  global.CSS_CLASSES = CSS_CLASSES;
  global.KEYCODES = KEYCODES;

  // Also create a constants object for easier access
  global.Constants = {
    BREAKPOINTS,
    ANIMATION_DURATION,
    CSS_CLASSES,
    KEYCODES,
  };

  // CommonJS compatibility (if needed)
  if (typeof module !== "undefined" && module.exports) {
    module.exports = {
      BREAKPOINTS,
      ANIMATION_DURATION,
      CSS_CLASSES,
      KEYCODES,
    };
  }
})(typeof window !== "undefined" ? window : this);
